module.exports = __webpack_public_path__ + "static/media/alert_icon_correct.743cd945.svg";